import React, { FC } from 'react';
import { PagesNavigationArrow } from './PagesNavigationArrow';
import { Element, fullWidth, scale as initialScale, notchBottom } from '@components/frame';
import { PictureProps } from '@v2/components/imageHandling/components/Picture';
import { ImageDocumentStoreItem, PageChangeActionType } from '@v2/components/imageHandling/types/types.d';
import { font as initialFont } from '@styles/fonts';
import { isPhone } from '@helpers';
import { Text } from 'react-native';
import i18n from 'i18n-js';
import { ACTIVE_THUMBNAIL_HEIGHT } from '@v2/components/imageHandling/constants';

interface PagesNavigationProps extends Pick<PictureProps, 'C' | 'scale' | 'font' | 'width'> {
  image: ImageDocumentStoreItem;
  showActions: boolean;
}

export const PagesNavigation: FC<PagesNavigationProps> = ({ C, image, showActions, width = fullWidth, scale = initialScale, font = initialFont }) => {
  const pageCount = image?.pageCount;

  if (!showActions || !image || !pageCount || pageCount <= 1) {
    return null;
  }

  return (
    <Element
      {...{
        config: {
          width: 184,
          height: 36,
          zIndex: 100 ,
          horizontalCenter: 0,
          parentWidth: width,
          position: {
            bottom: ACTIVE_THUMBNAIL_HEIGHT + 30 + notchBottom,
          },
        },
        scale,
      }}
    >
      <Element
        {...{
          config: {
            position: {
              top: 5,
            },
            width: 184,
            height: 26,
            backgroundColor: C('Overlay/Light/Dim strong'),
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            borderRadius: scale(13),
          },
          scale,
        }}
      >
        <Text style={[font['Caption 2'], { color: C('Label/Light/AlwaysLight Primary') }]}>
          {i18n.t('Page')} {image?.pageNumber} {i18n.t('of')} {image?.pageCount}
        </Text>
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: -9,
              left: -9,
            },
            width: 54,
            height: 54,
          },
          scale,
        }}
      >
        <PagesNavigationArrow pageChangeActionType={PageChangeActionType.PREV} C={C} image={image} />
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: -9,
              right: -9,
            },
            transform: [{ rotate: '180deg' }],
            width: 54,
            height: 54,
          },
          scale,
        }}
      >
        <PagesNavigationArrow pageChangeActionType={PageChangeActionType.NEXT} C={C} image={image} />
      </Element>
    </Element>
  );
};
